<div class="form-review-information-section form-review-event-information">
  <div class="form-review-section form-review-personal-contact">
    <div class="form-review-event-information-item">
      <p><%= event.start_date %> <%= event.start_time %> - <%= event.end_time %></p>
      <% if (event.location.name) { %>
        <p><%= event.location.name %></p>
      <% }%>
      <% if (event.location.address) { %>
        <p><%= event.location.address %></p>
      <% }%>
    </div>
  </div>
</div>
